import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// import AddButton from '../../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import ExportLabel from '../../components/common/ExportLabel/Export';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';

import authenticatedAxios from '../../authenticatedAxios';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import useFilterStore from '../../store/useFilterStore';
import useRefreshStore from '../../store/useRefreshStore';
import ApprovalButton from '../../components/common/ApprovalButton/ApprovalButton';
import {
  getUserLimitExtensions,
  approveUserLimitExtension,
  rejectUserLimitExtension
} from "../../services/FreeTrial/FreeTrail";


const pageKey = "users_requests";

const Usersrequests = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await getUserLimitExtensions();
      setItems(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await approveUserLimitExtension(id);
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleReject = async (id) => {
    try {
      await rejectUserLimitExtension(id);
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────────

  return (
    <div className="whole-container">

      <div className="top-heading">
        <PageHeader pageName="Free Trial /" nestedpageName="Users Requests" linkTo="" />
        <div className="export-container">
          {/* <ArchiveSelectedItem
           selectedItems={selectedItems} /> */}
          {/* <ExportLabel/> */}
        </div>
      </div>

      <div className="pagename-container">
        <div className="page-name">
          <h1 className="common-text fts-22 ftw-6 blue">Users Requests</h1>
        </div>
        <div className="pagename-right-container">
          {/* <AddButton onClick={handleNewClick} /> */}
          {/* <SimpleSearchBox
            placeholder="Search Free Trial Users"
            onSearchSelect={handleSearchSelect}
            defaultValue={searchParams?.term}
          /> */}
          {/* <Filter
            options={filterOptions}
            onFilterSelect={handleFilterSelect}
            defaultValue={selectedFilterOption}
          /> */}
          <Sort/>
        </div>
      </div>

      <div className="table-container">
        <table className="common-table">
          <thead className="common-table-head">
            <tr className="common-table-thead-tr">
              <th className="d-flex ai-center">
                 <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                  />
                COMPANY Name
              </th>
              <th>Request date</th>
              <th>Current USER limit</th>
              <th>Plan</th>
              <th>Requested User Increase</th>
              <th></th>
            </tr>
          </thead>

          <tbody className="common-table-tbody">
            {items.length === 0 ? (
              <tr>
                <td colSpan="6">No data found</td>
              </tr>
            ) : (
              items.map((item) => (
                <tr key={item.id}>
                  <td className="ai-center">
                    <input type="checkbox" />
                    {item.company_name}
                  </td>

                  <td>
                    {new Date(item.created_datetime).toLocaleDateString()}
                  </td>

                  <td>{item.current_user_count || "—"}</td>

                  <td>{item.plan_name || "—"}</td>

                  <td>{item.additional_user_count || "—"}</td>

                  <td>
                    <ApprovalButton
                      status={item.status}
                      onApprove={() => handleApprove(item.id)}
                      onReject={() => handleReject(item.id)}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      
    </div>
  );
};

export default Usersrequests;